import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, { ReactNode, ReactNodeArray } from 'react';
import SliderLead from './SliderLead.js';
import SliderLeadBlockData from '../../../Models/Content/SliderLeadBlockData';

export default class SliderLeadBlock extends EpiComponent<SliderLeadBlockData> {

  public render(): ReactNode | ReactNodeArray | null {
    const cssClasses: Array<string> = ['slider-lead-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <SliderLead
          context={this.getContext()}
          iContent={this.props.data}
        />
      </div>
    );
  };
};

